<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <!--ヘッダーにmax-width1920がいらない時はここを削除。対応する</div>も一緒に-->
      <div class="m-width1920">
        <div class="d-flex align-items-center">
          <!--ここまで↑-->
          <a class="navbar-brand" href="/">
            <img
              class="navbar-logo"
              src="@/assets/img/logo/treasure_logo.png"
              alt="野球グラブのオーダーメイドシミュレーション | Treasure ロゴ"
            />
          </a>
          <div class="nav-link">
            利用規約
          </div>
        </div>
      </div>
    </nav>
    <!--固定ヘッダー-->

    <div class="container mt-5 confirmation-main text-color-fff">
      <h2 class="text-center">利用規約</h2>
      <p class="mt-5">
        この利用規約（以下「本規約」といいます。）は、有限会社間瀬土木（以下「当社」といいます。）が提供するオーダーグラブシミュレーションサービス（以下「本サービス」といいます。）のご利用条件を定めるものです。本サービスをご利用いただいたお客様（以下「ユーザー」といいます。）は、本規約に同意したものとみなします。
      </p>

      <div class="mt-5">
        <h5 class="mt-5">第1条（本サービスについて）</h5>
        <p>
          本サービスは、ユーザーがグラブの型・仕様・カラー等を選択し、完成イメージを画面上でシミュレーションのうえご注文いただくことを目的としたサービスです。
        </p>

        <h5 class="mt-5">第2条（グラブの色・素材について）</h5>
        <p>
          シミュレーション画面に表示される色・質感は、実際の商品と多少異なる場合があります。また、ご利用の端末・ディスプレイの設定によっても、色の見え方が異なることがあります。
        </p>
        <p>
          本体レザー・ヘリ革・紐・ステッチ等は、同じ色の名称であっても部材によって色目が異なる場合があります。また、天然皮革の特性上、ご使用による多少の色落ち・色移りは避けられません。
        </p>

        <h5 class="mt-5">第3条（左投げ用グラブのデザインについて）</h5>
        <p>
          左投げ用グラブをご選択の場合、ウェブ等の左右非対称なデザインは、右投げ用の表示を左右反転したものとなります。実際の仕上がりの印象が表示と異なる場合がありますので、あらかじめご了承ください。
        </p>

        <h5 class="mt-5">第4条（刺繍・ネームについて）</h5>
        <p>
          刺繍の位置・内容・書体カラー・カゲカラー・フチカラー等は、シミュレーション画面にてご確認のうえご注文ください。グラブの型により刺繍を入れるスペースが限られるため、ご希望の大きさ・文字数が収まらない場合があります。
        </p>
        <p>
          ご注文確定後の刺繍内容の変更は、原則としてお受けできません。
        </p>

        <h5 class="mt-5">第5条（使用規定の確認について）</h5>
        <p>
          高校野球など、ご利用される連盟・大会ごとに使用できるグラブの規定（型・仕様・色等）が定められている場合があります。硬式用グラブをご注文されるお客様は、ご注文前に必ず各連盟・大会の規定をご確認ください。
        </p>
        <p>
          規定に適合しないグラブをご注文された場合であっても、オーダーメイドの特性上、返品・交換はお受けできません。
        </p>

        <h5 class="mt-5">第6条（注文内容の確認・変更・キャンセル）</h5>
        <p>
          ユーザーは、注文を確定する前に、選択した型・仕様・カラー・刺繍内容等をご自身で十分にご確認ください。ご注文確定後の内容変更・キャンセルは、原則としてお受けできません。
        </p>

        <h5 class="mt-5">第7条（禁止事項）</h5>
        <p>ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。</p>
        <ul>
          <li>法令または公序良俗に違反する行為</li>
          <li>当社または第三者の知的財産権その他の権利を侵害する行為</li>
          <li>虚偽の情報を登録する行為</li>
          <li>本サービスの運営を妨害する行為、または当社のサーバーやネットワークに過度な負荷をかける行為</li>
          <li>その他、当社が不適切と判断する行為</li>
        </ul>

        <h5 class="mt-5">第8条（免責事項）</h5>
        <p>
          本サービスのご利用は、お客様ご自身の責任において行うものとします。本サービスおよび本サービスからリンクする他のウェブサイトの内容、またはその利用によって生じた損害について、当社は一切の責任を負いません。
        </p>
        <p>
          当社は、システムの保守・点検、または地震・停電等の不可抗力により、ユーザーへの事前の告知なく本サービスの全部または一部の提供を停止・中断することがあります。
        </p>

        <h5 class="mt-5">第9条（個人情報の取扱い）</h5>
        <p>
          当社は、本サービスのご利用にあたりお預かりする個人情報を、暗号化等の方法により適切に保護し、当社「<router-link :to="{ name: 'PrivacyPolicy' }" class="terms-link">プライバシーポリシー</router-link>」に従って取り扱います。
        </p>

        <h5 class="mt-5">第10条（推奨環境）</h5>
        <p>
          本サービスは、各OS最新版のGoogle Chrome、Safari、Microsoft Edge、Firefoxでのご利用を推奨しております。推奨環境以外でご利用の場合、画面が正しく表示されない、または一部機能がご利用いただけない場合があります。
        </p>
        <p>
          本サービスではJavaScriptを使用しております。ブラウザの設定でJavaScriptを無効にされている場合は、正しく動作しない場合がありますので、有効にしてご利用ください。
        </p>

        <h5 class="mt-5">第11条（本規約の変更）</h5>
        <p>
          当社は、必要と判断した場合には、ユーザーへの事前の通知なく本規約を変更することができるものとします。変更後の規約は、本サイト上に表示した時点より効力を生じます。
        </p>

        <h5 class="mt-5">第12条（準拠法・裁判管轄）</h5>
        <p>
          本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関して紛争が生じた場合には、当社の本店所在地を管轄する裁判所を専属的合意管轄とします。
        </p>

        <div class="mt-5 text-center form-row mt-4 form__btn_gap">
          <div class="col">
            <button
              type="button"
              class="w-50 form-btn-block form-btn-secondary btn btn-block"
              @click="$router.back()"
            >
              戻る
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  p,
  li {
    font-size: 14px;
  }
  .terms-link {
    color: #fff;
    text-decoration: underline;
  }
</style>
